import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as myGlobals from '../../globals'; // <==== this one (**Updated**)
import { ResponseData } from 'src/app/models/ResponseData';
import { Observable } from 'rxjs';
import { SessionStorageService } from '@app/services/session-storage-service.service';

@Injectable({
  providedIn: 'root',
})
export class MiscellaneousService {
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Headers': '*',
      'Access-Control-Allow-Methods': '*',
      'Access-Control-Allow-Credentials': 'true',
      Accept: 'application/json',
      // Authorization: `Bearer`,
    }),
  };
  constructor(private http: HttpClient, private sessionStorageService: SessionStorageService) {}

  getLanguages(): Observable<any> {
    const url = `${myGlobals.apiBaseUrl}miscellaneous/languages`;
    return this.sessionStorageService.getData(url);
  }

  getQueries() {
    return this.http.get(`${myGlobals.apiBaseUrl}miscellaneous/getdata`);
  }

  getCompanies(username: string) {
    return this.http.get(
      `${myGlobals.apiBaseUrl}miscellaneous/companies?username=${username}`
    );
  }

  getLoginConditionsData() {
    return this.http.get(
      `${myGlobals.apiBaseUrl}miscellaneous/GetLoginConditionsData`
    );
  }

  getSignupLink() {
    return this.http.get(`${myGlobals.apiBaseUrl}miscellaneous/GetSignupLink`);
  }

  createToken(username: string, password: string, companyDB: string) {
    const lang = localStorage.getItem('language');
    return this.http.post(
      `${myGlobals.apiBaseUrl}authenticate/GetToken`,
      JSON.stringify({
        username,
        password,
        companyDB,
        language: lang,
      }),
      {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
      }
    );
  }
  resetPassword(
    email: string,
    token: string,
    password: string,
    rePassword: string,
    bwebUser,
    forgotPass: boolean,
    currentPass?: string
  ) {
    return this.http.post(`${myGlobals.apiBaseUrl}authenticate/ResetPassword`, {
      email,
      token,
      password,
      rePassword,
      bwebUser,
      forgotPass,
      currentPass,
    });
  }
  logoutOthers(): Observable<ResponseData<number>> {
    return this.http.get<ResponseData<number>>(
      `${myGlobals.apiBaseUrl}authenticate/LogoutOthers`
    );
  }
  SendAuthenticationRequest(email: string) {
    return this.http.get(
      `${myGlobals.apiBaseUrl}authenticate/SendResetRequest?Email=${email}`
    );
  }
  getQrImage(qrString: string) {
    return this.http.get(
      `https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${qrString}`,
      { responseType: 'blob' }
    );
  }
  auth2FAWithSharedKey(loginkey: string, sharedKey: string) {
    return this.http.post(
      `${myGlobals.apiBaseUrl}authenticate/ValidateQrWithSharedKey`,
      {
        loginKey: loginkey,
        sharedKey: sharedKey,
      }
    );
  }
  auth2FAKey(loginKey: string, sessionTempKey: string) {
    return this.http.post(
      `${myGlobals.apiBaseUrl}authenticate/Validate2FAKey`,
      {
        loginKey: loginKey,
        sessionTempKey: sessionTempKey,
      }
    );
  }
  skip2FA(sessionTempKey: string) {
    return this.http.get(
      `${myGlobals.apiBaseUrl}authenticate/Skip2FA?sessionTempKey=${sessionTempKey}`
    );
  }
}
